module.exports = __webpack_public_path__ + "static/media/google-icon.14137f89.svg";